import { RootState } from '@app/redux/root-reducer';

export const selectMyProfileFormState = (store: RootState) => store.myProfileReducer.profile;

export const selectMyProfile = (store: RootState) => store.myProfileReducer.profile?.data;

export const selectUpdateMyProfile = (store: RootState) => store.myProfileReducer.updateProfile;
